import { useCallback, useMemo } from "react";
import moviesJson from "src/Data/movies.json";
import Config from "src/Constants/Config";

import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import HomePage from "../HomePage";

import setCurrentUser from "src/Utils/setCurrentUser";
import Movies from "../Movies";

const generateMovies = (baseImages: string): MovieType[] => [
  ...moviesJson.map((movie) => ({ ...movie, image: `${baseImages}${movie.image}` })),
];

interface MainScreenProps {
  pageId: number;
  step: number;
  stepVisited: any;
  setStep: (step: number) => void;
}

const MainScreen = ({ pageId, step, stepVisited, setStep }: MainScreenProps) => {
  const baseImagesMovies = `${Config.BASE_URL}/images/movies/`;

  const movies = useMemo(() => generateMovies(baseImagesMovies), [baseImagesMovies]);

  const currentUser = useSelector(() => store.getState().appReducer.currentUser);

  const filterMoviesByCategory = useCallback(
    (category: string, needFirst: boolean) => {
      let filteredMovies = movies.filter((movie) => movie.categories.includes(category));

      if (needFirst) {
        const pulseMovieIndex = filteredMovies.findIndex((movie) => movie.pulse);
        if (pulseMovieIndex !== -1) {
          const [pulseMovie] = filteredMovies.splice(pulseMovieIndex, 1);
          const randomIndex = Math.floor(Math.random() * Math.min(3, filteredMovies.length + 1));
          filteredMovies.splice(randomIndex, 0, { ...pulseMovie, pulse: pageId !== 3 });
        }
      }

      return filteredMovies;
    },
    //eslint-disable-next-line
    [movies]
  );

  const continueWatching = useMemo(() => filterMoviesByCategory(currentUser, true), [currentUser, filterMoviesByCategory]);
  const recommendedMovies = useMemo(
    () => filterMoviesByCategory(`recommendFor${currentUser[0].toUpperCase()}${currentUser.slice(1)}`, false),
    [filterMoviesByCategory, currentUser]
  );
  const trendingMovies = useMemo(() => filterMoviesByCategory("trend", false), [filterMoviesByCategory]);
  const lastChanceMovies = useMemo(() => filterMoviesByCategory("lastChange", false), [filterMoviesByCategory]);

  return (
    <>
      {step !== 2 && (
        <>
          <HomePage
            step={step}
            stepVisited={stepVisited}
            setStep={setStep}
            pageId={pageId}
            currentUser={currentUser}
            setCurrentUser={setCurrentUser}
            continueWatching={continueWatching}
          />
          <div style={{ paddingLeft: "var(--width-71)", paddingTop: "var(--height-10)" }}>
            <Movies size="small" title="Recommended for You" data={recommendedMovies} />
            <Movies size="small" title="Trending Now" data={trendingMovies} />
            <Movies size="small" title="Last Chance to Watch" data={lastChanceMovies} />
          </div>
        </>
      )}
    </>
  );
};

export default MainScreen;
